import { loadLocalStorage, storeLocalStorage } from '../../shared/services/storage.service';

const KEY = 'mainNotice';

interface MainNoticeItem {
  id: number;
  noShowTime: number;
}

export const loadMainNotices = (): MainNoticeItem[] => {
  return loadLocalStorage(KEY) || [];
};

export const storeMainNotice = (notice: MainNoticeItem) => {
  const previousNotices = loadMainNotices();

  return storeLocalStorage(KEY, [...previousNotices.filter(({ id }) => id !== notice.id), notice]);
};
